import { cache_read, cache_write, helps_cacheName } from "src/components/js/CacheFunctions";

export default class helpClass {
  constructor() {}
  id;
  helpId;
  img;
  title;
  shorttext;
  htmltext;
  rev;
  accessCount;
  entryTime;
  lastAccessTime;
  lastModifiedTime;
}

export function fetchHelp(helpId) {
  if (helpId == "") return null;
  const url = import.meta.env.VITE_SERVER_URL + "/api/helps/get/" + helpId;
  const c = cache_read(helps_cacheName, url);
  if (c) {
    return processFetchHelpJson(c);
  }

  const res = fetch(url)
    .then((res) => res.json())
    .then((json) => {
      cache_write(helps_cacheName, url, json, 3600);
      return processFetchHelpJson(json);
    })
    .catch((error) => {
      console.log(helpId);
      throw error;
    });
  return res;
}

function processFetchHelpJson(json) {
  if (json.length > 0) {
    const help = new helpClass();
    help.accessCount = json[0].accessCount;
    help.entryTime = json[0].entrytime;
    help.helpId = json[0].helpId;
    help.htmlText = json[0].htmltext;
    help.id = json[0].id;
    help.img = json[0].img;
    help.lastAccessTime = json[0].lastAccessTime;
    help.lastModifiedTime = json[0].lastModifiedTime;
    help.rev = json[0].rev;
    help.shortText = json[0].shorttext;
    help.title = json[0].title;
    return help;
  } else {
    return null;
  }
}

export async function fetchAllHelps() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/helps/getall";
  const c = cache_read(helps_cacheName, url);
  if (c) return c;

  const res = await fetch(url);
  const json = await res.json();
  const processed = processFetchAllHelpsJson(json);
  cache_write(helps_cacheName, url, processed, 3600);
  return processed;
}

function processFetchAllHelpsJson(json) {
  const helps = [];
  json.forEach((element) => {
    const help = new helpClass();
    help.accessCount = element.accessCount;
    help.entryTime = element.entrytime;
    help.helpId = element.helpId;
    help.htmlText = element.htmltext;
    help.id = element.id;
    help.img = element.img;
    help.lastAccessTime = element.lastAccessTime;
    help.lastModifiedTime = element.lastModifiedTime;
    help.rev = element.rev;
    help.shortText = element.shorttext;
    help.title = element.title;
    helps.push(help);
  });
  return helps;
}
